import Vue from 'vue'

Vue.mixin({

	data: () => ({

		buttonStatus: false,

		loadingStatus: false,

	}),

    methods: {

		async prepareAction(functionName, loadingName = 'loadingStatus', buttonStatus = 'buttonStatus', params = null) {
				
			this[buttonStatus] = true;
			
			this[loadingName]  = true;
			
			await this[functionName](params);
			
			this[loadingName]  = false;
			
			this[buttonStatus] = false;

		},

    }

});




// WEBPACK FOOTER //
// ./src/mixins/globalMixin.js